import { initVastuTool } from './vastu.ts';
import { initBirthChartTool } from './birth-chart.ts';
import { initLuckyColorsTool } from './lucky-colors.ts';
import { initKundliTool } from './kundli.ts';
import { checkTimezoneSupport, initPlaceInput } from './birth-details.ts';

/**
 * Entry point for the /tools bundle.
 *
 * Each tool checks for its own form and no-ops when absent, so one bundle
 * serves every tool route without shipping per-page entry points. The bundle
 * is only loaded by pages that declare it (see `scripts` in WrapOpts) — it is
 * never pulled onto the marketing pages.
 */
function boot(): void {
  // Any form carrying the shared birth-details fieldset gets its place
  // autocomplete and the historical-timezone capability probe.
  document.querySelectorAll<HTMLFormElement>('form[data-birth-details]').forEach((form) => {
    initPlaceInput(form);
    checkTimezoneSupport(form);
  });

  initVastuTool();
  initBirthChartTool();
  initLuckyColorsTool();
  initKundliTool();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
